import Upload from "@mui/icons-material/Upload";
import { Button } from "@mui/material";

import { Event } from "../../hooks/events";

const toCSV = (headers: string[], data: Event[] | undefined) => {
  if (!data) return "";

  let str = headers.join(",").concat("\n");

  for (const event of data) {
    let line = "";

    for (const key of headers) {
      // console.log(`${key}:`, event[key]);

      if (line !== "") line += ",";

      if (key === "message") {
        line += event[key].replace(/\n/g, " ");
      } else if (key === "key") {
        line += event["key"]?.["name"] || "--";
      } else if (key === "project") {
        line += event["project"]?.["name"] || "--";
      } else {
        line += event[key] || "--";
      }
    }

    str += line + "\r\n";
  }

  // const array = typeof data !== "object" ? JSON.parse(data) : data;

  // // note: included in case needed in future
  // if (array.length > 0 && typeof array[0] === "string") {
  //   // array of strings
  //   str = array.join("\r\n");
  // }

  return str;
};

const CSV = (props: {
  data: Event[] | undefined;
  headers: string[];
  fileName: string;
  disabled?: boolean;
}) => {
  const { data, headers, fileName, disabled = false } = props;

  const exportCSV = () => {
    const csvData = new Blob([toCSV(headers, data)], { type: "text/csv" });

    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = csvURL;
    link.download = `${fileName}-${new Date().toISOString()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      color="secondary"
      variant="contained"
      disabled={disabled}
      onClick={exportCSV}
      endIcon={<Upload />}
    >
      Export
    </Button>
  );
};

export default CSV;
